<template>
    <div class="terms-wrapper">
        <app-header-mini :img="'/static/img/disclosure_policy/header.jpg'"></app-header-mini>
        <div class="terms-content">
            <h1 class="indent">Politica di divulgazione delle informazioni</h1>
            <p class="indent">La politica di divulgazione delle informazioni di ALCOMET AD è direttamente collegata alle esigenze dei suoi investitori e azionisti di ottenere informazioni aggiornate, adeguate, sufficientemente dettagliate e trasparenti. Il comportamento professionale ed etico della Società nei confronti di tutti i suoi partners la pone in una posizione di attrattiva entità di investimento che incide direttamente sull'interesse per le sue azioni nel mercato azionario.</p>
            <p class="indent">L'efficiente programma di divulgazione delle informazioni promuove il raggiungimento degli obiettivi fissati al momento della quotazione della Società con la BSE, vale a dire: migliore accesso agli investimenti, miglioramento della commercializzazione dei prodotti e del posizionamento generale della Società, attrazione di una più ampia gamma di controparti commerciali, fornitori e parti sociali per progetti comuni, agevolazione della raccolta fondi attraverso l'emissione di titoli e una corretta preparazione del mercato dei capitali, garantendo una maggiore flessibilità e sicurezza degli azionisti in merito ai loro investimenti, un uso più efficiente degli operatori professionali del mercato dei capitali per migliorare la liquidità dei titoli emessi dalla Società e una maggiore presenza della Società nei media nelle pubblicazioni specializzate.</p>
            <p class="indent">Il programma di divulgazione delle informazioni di ALCOMET AD include i risultati finanziari e operativi della Società, gli obiettivi della Società, le principali partecipazioni azionarie e i diritti di voto, i membri del Consiglio di gestione e di vigilanza, compresi gli amministratori esecutivi e le loro funzioni, i fattori di rischio rilevanti e prevedibili, le questioni rilevanti relative ai dipendenti e alle altre parti interessate e la struttura e la politica di governo societario.</p>
        </div>
    </div>
</template>

<script>
import HeaderMini from "./shared/HeaderMini";
export default {
  components: {
    appHeaderMini: HeaderMini
  }
};
</script>

<style scoped>
.terms-content {
  padding: 0 0 60px;
}
.terms-content > h1 {
  font-size: 34px;
  font-weight: 500;
  margin: 0 auto 25px;
  width: 800px;
}
.terms-content > p {
  font-size: 19px;
  text-align: justify;
  line-height: 32px;
  margin: 15px auto;
  width: 800px;
}
@media screen and (max-width: 1000px) {
  .terms-content > h1 {
    font-size: 20px;
    padding: 0 30px;
    width: 100%;
  }
  .terms-content > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DisclosurePolicy.vue